import { useTranslation } from "react-i18next";
import { messages } from "../../../../../locales/messages";
import { ReviewEmptyState } from "../state/ReviewEmptyState";

/** Empty state shown when the flyer has no items with review activity. */
export function ChangesByItemEmptyState() {
  const { t } = useTranslation();
  return (
    <ReviewEmptyState
      testId="changes-by-item-empty"
      title={t(messages.No_Items_With_Changes_Yet())}
      subtitle={t(messages.Review_Select_Item_Hint())}
    />
  );
}
